/**
 * Per-playbook image mapping
 *
 * Single source of truth: the same image is used on the card AND the detail page.
 * Uses solution page images across different markets to ensure visual variety.
 */

// One image per playbook — used on cards AND detail page hero
const playbookImages: Record<string, string> = {
  // --- Provide Support (6) ---
  'interactive-faq': '/playbooks/support/interactive-faq.webp',
  'smart-escalation': '/playbooks/support/smart-escalation.webp',
  'internal-learning-assistant': '/playbooks/support/internal-learning-assistant.webp',
  'web-embed-assistant': '/playbooks/support/web-embed-assistant.webp',
  'proactive-problem-solver': '/playbooks/support/proactive-problem-solver.webp',
  'status-page-communicator': '/playbooks/support/status-page-communicator.webp',

  // --- Capture Leads (5) ---
  'proactive-welcome': '/playbooks/lead-capture/proactive-welcome.webp',
  'contact-form-2': '/playbooks/lead-capture/contact-form-2.webp',
  'exit-intent-offer': '/playbooks/lead-capture/exit-intent-offer.webp',
  'demo-scheduler': '/playbooks/lead-capture/demo-scheduler.webp',
  'cold-outreach': '/playbooks/lead-capture/cold-outreach.webp',

  // --- Physical World (4) ---
  'retail-product-assistant': '/playbooks/physical-world/retail-product-assistant.webp',
  'equipment-troubleshooting': '/playbooks/physical-world/equipment-troubleshooting.webp',
  'venue-concierge': '/playbooks/physical-world/venue-concierge.webp',
  'interactive-exhibit': '/playbooks/physical-world/interactive-exhibit.webp',

  // --- Onboard & Educate (3) ---
  'first-login-welcome': '/playbooks/onboarding/first-login-welcome.webp',
  'feature-explainer': '/playbooks/onboarding/feature-explainer.webp',
  'pro-tip-nudge': '/playbooks/onboarding/pro-tip-nudge.webp',

  // --- Amplify Marketing (4) ---
  'limited-time-offer': '/playbooks/marketing/limited-time-offer.webp',
  'personal-shopper': '/playbooks/marketing/personal-shopper.webp',
  'social-proof-messenger': '/playbooks/marketing/social-proof-messenger.webp',
  'lead-magnet-delivery': '/playbooks/marketing/lead-magnet-delivery.webp',

  // --- Gather Insights (4) ---
  'post-purchase-survey': '/playbooks/insights/post-purchase-survey.webp',
  'customer-check-in': '/playbooks/insights/customer-check-in.webp',
  'voice-survey': '/playbooks/insights/voice-survey.webp',
  'testimonial-harvester': '/playbooks/insights/testimonial-harvester.webp',
};

// Category-level fallback images
export const categoryHeroImages: Record<string, string> = {
  'support': '/playbooks/support-hero.webp',
  'physical-world': '/playbooks/physical-world-hero.webp',
  'lead-capture': '/playbooks/lead-capture-hero.webp',
  'onboarding': '/playbooks/onboarding-hero.webp',
  'marketing': '/playbooks/marketing-hero.webp',
  'insights': '/playbooks/insights-hero.webp',
};

/** Get the image for a playbook — same image on card and detail page */
export const getPlaybookImage = (playbookId: string, categorySlug?: string): string => {
  return playbookImages[playbookId]
    || categoryHeroImages[categorySlug || '']
    || '/hero-background.webp';
};
